/************
 * Developed by : Shiva Software Solutions
 * Date : 10-02-2025
 * Descriptions : Route page for AI
 * Dependicies : To use @material-ui/core,react-router-dom,formik
 ************/
import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const googleStudioConfig = [
  {
    auth: authRole.user,
    routes: [
      {
        path: '/ai',
        component: React.lazy(() => import('./dischargePreInterface')),
      },
    ],
  },
];
